import React from "react";
import PropTypes from "prop-types";
import { Input as AntInput } from "antd";

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  id: null,
  name: null,
  placeholder: null,
  type: "text",
};

function TextInput({ ...props }) {
  return <AntInput {...props} />;
}

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;
